import {
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_BEGIN,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_SUCCESS,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_FAILURE,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadExternalDatabaseForAirtable(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_BEGIN,
    });
    const { projectId, version, externalDbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/airtable/${externalDbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissLoadExternalDatabaseForAirtableError() {
  return {
    type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_BEGIN:
      return {
        ...state,
        loadExternalDatabaseForAirtablePending: true,
        loadExternalDatabaseForAirtableError: null,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_SUCCESS:
      return {
        ...state,
        loadExternalDatabaseForAirtablePending: false,
        loadExternalDatabaseForAirtableError: null,
        externalDbAirtable: action.data,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_FAILURE:
      return {
        ...state,
        loadExternalDatabaseForAirtablePending: false,
        loadExternalDatabaseForAirtableError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseForAirtableError: null,
      };

    default:
      return state;
  }
}
